(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shinzo-pdp-faq"] && !Shopify.designMode) return;
  try {
    
  class ShinzoPdpFaq extends HTMLElement {
    #controller = new AbortController();

    connectedCallback() {
      const { signal } = this.#controller;

      this.addEventListener('click', this.#onClick, { signal });
      this.addEventListener('keydown', this.#onKeyDown, { signal });
    }

    disconnectedCallback() {
      this.#controller.abort();
      this.#controller = new AbortController();
    }

    #onClick = (event) => {
      const button = event.target.closest('.shinzo-pdp-faq__trigger');

      if (!button || !this.contains(button)) return;

      this.#toggle(button);
    };

    #onKeyDown = (event) => {
      if (event.key === 'Escape') {
        this.#closeFromEvent(event);
        return;
      }

      const button = event.target.closest('.shinzo-pdp-faq__trigger');

      if (!button || !this.contains(button)) return;

      const buttons = [...this.querySelectorAll('.shinzo-pdp-faq__trigger')];
      const index = buttons.indexOf(button);

      if (index < 0) return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        buttons[(index + 1) % buttons.length].focus();
        return;
      }

      if (event.key === 'ArrowUp') {
        event.preventDefault();
        buttons[(index - 1 + buttons.length) % buttons.length].focus();
        return;
      }

      if (event.key === 'Home') {
        event.preventDefault();
        buttons[0].focus();
        return;
      }

      if (event.key === 'End') {
        event.preventDefault();
        buttons[buttons.length - 1].focus();
      }
    };

    #closeFromEvent(event) {
      const item = event.target.closest('.shinzo-pdp-faq__item');

      if (!item || !this.contains(item)) return;

      const button = item.querySelector('.shinzo-pdp-faq__trigger');

      if (!button || button.getAttribute('aria-expanded') !== 'true') return;

      event.preventDefault();
      this.#setExpanded(button, false);
      button.focus();
    }

    #toggle(button) {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      this.#setExpanded(button, !expanded);
    }

    #setExpanded(button, expanded) {
      const panelId = button.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : null;

      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');

      if (panel) {
        panel.hidden = !expanded;
      }
    }
  }

  if (!customElements.get('shinzo-pdp-faq')) {
    customElements.define('shinzo-pdp-faq', ShinzoPdpFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shinzo-pdp-instructions"] && !Shopify.designMode) return;
  try {
    
  class ShinzoPdpInstructions extends HTMLElement {
    #options = [];
    #copies = [];

    connectedCallback() {
      this.#options = [...this.querySelectorAll('[data-method-option]')];
      this.#copies = [...this.querySelectorAll('[data-method-copy]')];

      for (const option of this.#options) {
        option.addEventListener('click', () => {
          this.#setMethod(option.dataset.methodOption);
        });

        option.addEventListener('keydown', (event) => {
          this.#onOptionKeydown(event, option);
        });
      }

      const initialMethod = this.dataset.defaultMethod || 'whisk';
      this.#setMethod(initialMethod);
    }

    #onOptionKeydown(event, option) {
      const forward = event.key === 'ArrowRight' || event.key === 'ArrowDown';
      const backward = event.key === 'ArrowLeft' || event.key === 'ArrowUp';

      if (!forward && !backward) return;

      event.preventDefault();

      const index = this.#options.indexOf(option);
      const nextIndex = forward
        ? (index + 1) % this.#options.length
        : (index - 1 + this.#options.length) % this.#options.length;
      const next = this.#options[nextIndex];

      if (!next) return;

      this.#setMethod(next.dataset.methodOption);
      next.focus();
    }

    #setMethod(method) {
      if (!method) return;

      for (const option of this.#options) {
        const isActive = option.dataset.methodOption === method;
        option.classList.toggle('is-active', isActive);
        option.setAttribute('aria-checked', isActive ? 'true' : 'false');
        option.tabIndex = isActive ? 0 : -1;
      }

      for (const copy of this.#copies) {
        copy.hidden = copy.dataset.methodCopy !== method;
      }

      this.dataset.method = method;
    }
  }

  if (!customElements.get('shinzo-pdp-instructions')) {
    customElements.define('shinzo-pdp-instructions', ShinzoPdpInstructions);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shinzo-pdp-photo-scroll"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.shinzo-pdp-photo-scroll');

    sections.forEach(function (section) {
      var viewport = section.querySelector('.shinzo-pdp-photo-scroll__viewport');
      var track = section.querySelector('.shinzo-pdp-photo-scroll__track');
      if (!viewport || !track) return;

      var desktopMq = window.matchMedia('(min-width: 750px)');

      var updateScrollingState = function () {
        section.classList.remove('shinzo-pdp-photo-scroll--static');

        if (!desktopMq.matches) {
          return;
        }

        var hasOverflow = track.scrollWidth > viewport.clientWidth + 1;
        if (!hasOverflow) {
          section.classList.add('shinzo-pdp-photo-scroll--static');
        }
      };

      var images = track.querySelectorAll('img');
      var pendingImages = 0;

      images.forEach(function (img) {
        if (img.complete) {
          return;
        }

        pendingImages += 1;

        var onImageReady = function () {
          pendingImages -= 1;
          if (pendingImages <= 0) {
            updateScrollingState();
          }
        };

        img.addEventListener('load', onImageReady, { once: true });
        img.addEventListener('error', onImageReady, { once: true });
      });

      if (typeof ResizeObserver !== 'undefined') {
        var ro = new ResizeObserver(updateScrollingState);
        ro.observe(viewport);
        ro.observe(track);
      } else {
        window.addEventListener('resize', updateScrollingState);
      }

      if (typeof desktopMq.addEventListener === 'function') {
        desktopMq.addEventListener('change', updateScrollingState);
      } else if (typeof desktopMq.addListener === 'function') {
        desktopMq.addListener(updateScrollingState);
      }

      updateScrollingState();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shinzo-pdp-review-summary"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const SOURCE_SELECTOR = '[data-review-summary]';
    const WRAPPER_SELECTOR = '.shinzo-pdp-review-summary-wrapper';
    const WIDGET_SELECTOR = '#klaviyo-product-reviews-wrapper';
    const AFTER_SELECTOR = '.kl_reviews__summary__grid--2-1';
    const PLACED_CLASS = 'shinzo-pdp-review-summary--placed';
    const RELOCATED_CLASS = 'shinzo-pdp-review-summary-wrapper--relocated';

    const placeSummary = () => {
      const source = document.querySelector(SOURCE_SELECTOR);
      const widget = document.querySelector(WIDGET_SELECTOR);
      if (!source || !widget) return false;

      const after = widget.querySelector(AFTER_SELECTOR);
      if (!after) return false;

      const stale = widget.querySelector('.' + PLACED_CLASS);
      if (stale && stale !== source) {
        stale.remove();
      }

      if (source.previousElementSibling !== after) {
        after.after(source);
      }

      source.classList.add(PLACED_CLASS);

      const wrapper = source.closest(WRAPPER_SELECTOR) || document.querySelector(WRAPPER_SELECTOR);
      if (wrapper) {
        wrapper.classList.add(RELOCATED_CLASS);
      }

      return true;
    };

    placeSummary();

    let attempts = 0;
    const poll = setInterval(() => {
      placeSummary();
      attempts += 1;
      if (attempts > 80) {
        clearInterval(poll);
      }
    }, 250);

    let debounce;
    const observer = new MutationObserver(() => {
      clearTimeout(debounce);
      debounce = setTimeout(placeSummary, 50);
    });

    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shinzo-pdp-testimonials"] && !Shopify.designMode) return;
  try {
    
  class ShinzoPdpTestimonials extends HTMLElement {
    #controller = new AbortController();

    connectedCallback() {
      this.#controller.abort();
      this.#controller = new AbortController();

      const { signal } = this.#controller;

      this.addEventListener('click', this.#onClick, { signal });
      this.addEventListener('keydown', this.#onKeyDown, { signal });
    }

    disconnectedCallback() {
      this.#controller.abort();
    }

    #tabs() {
      return [...this.querySelectorAll('.shinzo-pdp-testimonials__tab')];
    }

    #onClick = (event) => {
      const tab = event.target.closest('.shinzo-pdp-testimonials__tab');

      if (!tab || !this.contains(tab)) return;

      this.#select(tab);
    };

    #onKeyDown = (event) => {
      const tab = event.target.closest('.shinzo-pdp-testimonials__tab');

      if (!tab || !this.contains(tab)) return;

      const tabs = this.#tabs();
      const index = tabs.indexOf(tab);

      if (index < 0) return;

      const key = event.key;
      let next = null;

      if (key === 'ArrowRight') {
        next = tabs[index + 1];
      } else if (key === 'ArrowLeft') {
        next = tabs[index - 1];
      } else if (key === 'Home') {
        next = tabs[0];
      } else if (key === 'End') {
        next = tabs[tabs.length - 1];
      }

      if (!next || next === tab) return;

      event.preventDefault();
      this.#select(next);
      next.focus();
    };

    /**
     * @param {HTMLButtonElement} tab
     */
    #select(tab) {
      for (const item of this.#tabs()) {
        const selected = item === tab;

        item.setAttribute('aria-selected', selected ? 'true' : 'false');
        item.tabIndex = selected ? 0 : -1;

        const panelId = item.getAttribute('aria-controls');
        const panel = panelId ? this.querySelector(`[id="${panelId}"]`) : null;

        if (!panel) continue;

        panel.hidden = !selected;

        if (!selected) continue;

        const track = panel.querySelector('.shinzo-pdp-testimonials__track');

        if (track) {
          track.scrollLeft = 0;
        }
      }
    }
  }

  if (!customElements.get('shinzo-pdp-testimonials')) {
    customElements.define('shinzo-pdp-testimonials', ShinzoPdpTestimonials);
  }

  } catch(e) { console.error(e); }
})();
})();
